import { DeliveryStatus } from "@types_def/models/delivery.types";
import { UserRank } from "@types_def/models/user.type";

function hasRankAccess(rank: UserRank | undefined, minimumRank: UserRank) {
  if (rank === undefined) return true;

  return minimumRank >= rank;
}

export function canViewDeliveryActions(isAdmin: boolean, status: DeliveryStatus) {
  return (
    isAdmin ||
    [
      DeliveryStatus.REQUESTED,
      DeliveryStatus.CANCELLED_BY_CUSTOMER,
      DeliveryStatus.CANCELLED_BY_MANDATORY,
    ].includes(status)
  );
}

export function canUseAdminDeliveryActions(
  isAdmin: boolean,
  rank: UserRank | undefined,
  minimumRank = UserRank.MAINTAINER
) {
  return isAdmin && hasRankAccess(rank, minimumRank);
}
